import { get, post } from '@/api/general';

export default {
    add: (specificationId, params) => post(`cart/${specificationId}/add`, params),
    removeItem: (orderItemId) => post(`cart/${orderItemId}/remove/item`),
    getInfo: () => get('cart/info'),
    changeQty: (orderItemId, params) => post(`cart/${orderItemId}/changeQty`, params),
    createOrder: (params) => post('cart/createOrder', params),
};
